import { gql } from '@apollo/client';

export default gql`
  mutation checkInTicketsInSalesforce($bookingReference: String!, $tcnList: [String!]) {
    checkInTicketsInSalesforce(bookingReference: $bookingReference, tcnList: $tcnList)
  }
`;
